import React from 'react'
import { CreditApplication } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import ImageWrapper from '@sputnik/components/ImageWrapper/ImageWrapper'
import StatusButtons from '@sputnik/components/StatusButtons'
import { getPaymentNetwork } from '@sputnik/components/utils'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'
import { URL } from '@sputnik/resources/constants'
import { logInfo } from '@sputnik/utils/loggerUtils'

interface MigrationCompleteStatusTileProps {
  creditApp: CreditApplication
}

const MigrationCompleteStatusTile = ({ creditApp }: MigrationCompleteStatusTileProps) => {
  const { salesforceCreditId, dsaVersion } = creditApp || {}
  const [makeTestId] = useNameFormatter('MigrationCompleteStatusTile')
  const paymentNetwork = getPaymentNetwork(dsaVersion)

  const navigateToSpendAndExpense = () => {
    logInfo('goToSpendAndExpense', {
      attributes: {
        creditAppId: salesforceCreditId,
        result: `Sending user to path: https://app.divvy.co`,
      },
      eventName: 'RedirectToSpend&Expense',
    })
    window.open(URL.DIVVY_PROD, '_blank', 'noopener, noreferrer')
  }

  return (
    <div data-testid={makeTestId('')}>
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='team of 3 people high fiving'
            imageName='dashboard-application-visa-success-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage="You've finished your first step in switching over to {paymentNetwork}."
            id='sputnik.MigrationCompleteStatusTile__s/mAx+'
            values={{ paymentNetwork }}
          />
        }
        secondaryInfo={
          <>
            <div>
              <FormattedMessage
                defaultMessage='Your next steps:'
                id='sputnik.MigrationCompleteStatusTile__+ev+Dm'
              />
            </div>
            <ul className='migration-status-description-items'>
              <li>
                <FormattedMessage
                  defaultMessage='Add date of birth for your employees'
                  id='sputnik.MigrationCompleteStatusTile__uzzfB4'
                />
              </li>
              <li>
                <FormattedMessage
                  defaultMessage='Send your employees their new {paymentNetwork} cards'
                  id='sputnik.MigrationCompleteStatusTile__DrCGVL'
                  values={{ paymentNetwork }}
                />
              </li>
              <li>
                <FormattedMessage
                  defaultMessage='Update your virtual card numbers so you don’t miss a payment'
                  id='sputnik.MigrationCompleteStatusTile__QJ0+1g'
                />
              </li>
              <li>
                <FormattedMessage
                  defaultMessage='Transfer your credit limit to your {paymentNetwork} card.'
                  id='sputnik.MigrationCompleteStatusTile__ihT0an'
                  values={{ paymentNetwork }}
                />
              </li>
            </ul>
          </>
        }
        title={
          <FormattedMessage
            defaultMessage='Success!'
            id='sputnik.MigrationCompleteStatusTile__UIDXdt'
          />
        }
      >
        <StatusButtons
          hideSecondary
          primaryText={
            <FormattedMessage
              defaultMessage='Go to my {paymentNetwork} dashboard'
              id='sputnik.MigrationCompleteStatusTile__XN79TR'
              values={{ paymentNetwork }}
            />
          }
          onPrimaryClick={navigateToSpendAndExpense}
        />
      </StatusTile>
    </div>
  )
}

export default MigrationCompleteStatusTile
